import React, { useEffect, useState } from 'react';
import { API, Track, TrackArtist, TrackRelease } from '../../api';
import { useIsDesktop } from '../../style/constants';
import Loader from '../common/Loader';
import SharingModal from '../Modals/SharingModal';
import ReleasedTrackInfoMobile from './ReleasedTrackInfoMobile';
import ReleasedTrackInfoDesktop from './ReleasedTrackInfoDesktop';

function ReleasedTrackInfo({ track }: ReleasedTrackInfoProps) {
  const isDesktop = useIsDesktop();

  const [showShareModal, setShowShareModal] = useState(false);

  const [totalStreams, setTotalStreams] = useState<number>();
  const [totalEarned, setTotalEarned] = useState<number>();

  const [release, setRelease] = useState<TrackRelease>();

  const [contributors, setContributors] = useState<TrackArtist[]>([]);
  const [otherArtists, setOtherArtists] = useState<TrackArtist[]>([]);

  useEffect(() => {
    // TODO change to earnings is implemented in BE
    setTotalEarned(0);

    API.trackReleases
      .getReleaseStatisticsForTrack(track.id, 'all')
      .then((resp) => setTotalStreams(resp.total_streams || 0));

    API.trackReleases.getTrackRelease(track.id).then((resp) => {
      setRelease(resp.data);
      if (resp.data.length !== 0) {
        resp.data.artist_details.artists.forEach((artist: TrackArtist) =>
          artist.artist_type === 'CONTRIBUTOR'
            ? setContributors((prev) => [...prev, artist])
            : setOtherArtists((prev) => [...prev, artist]),
        );
      }
    });
  }, []);

  if (totalStreams === undefined || totalEarned === undefined || !release) {
    return (
      <div className="w-100 mt-3">
        <Loader />
      </div>
    );
  }
  const handleShareButtonClick = () => {
    setShowShareModal(true);
  };

  return (
    <>
      {isDesktop ? (
        <ReleasedTrackInfoDesktop
          track={track}
          totalStreams={totalStreams}
          totalEarned={totalEarned}
          onShareButtonClick={handleShareButtonClick}
          release={release}
          contributors={contributors}
          otherArtists={otherArtists}
        />
      ) : (
        <ReleasedTrackInfoMobile
          track={track}
          totalStreams={totalStreams}
          totalEarned={totalEarned}
          onShareButtonClick={handleShareButtonClick}
          release={release}
          contributors={contributors}
          otherArtists={otherArtists}
        />
      )}

      <SharingModal
        type="tracks"
        id={track.id}
        show={showShareModal}
        close={() => setShowShareModal(false)}
      />
    </>
  );
}

export default ReleasedTrackInfo;

interface ReleasedTrackInfoProps {
  track: Track;
}
